<template>
  <div class="cat" :style="{ width: myWidth + 'px' }">
    <h3 class="ui blue header" v-if="category">
      <div class="content">
        <a href="javascript:void(0)" @click="loadCategory(category.id)">{{
          category.label
        }}</a>
      </div>

      <div class="sub header">{{ category.description }}</div>
    </h3>

    <div class="sub-content">
      <div
        class="ui column fluid ui equal width height divided grid"
        v-if="category && category.children"
      >
        <div class="column" v-for="(line, index) in lines" :key="index">
          <template v-for="sub in line">
            <h4 class="ui header list-element show-icon">
              <a href="javascript:void(0)" @click="loadCategory(sub.id)">{{
                sub.label
              }}</a>
              <a href="javascript:void(0)" @click="copy(category.id, sub.id, brand._id)"
                ><i class="share alternate icon"></i
              ></a>
            </h4>
            <div class="ui link list">
              <div class="item show-icon" v-for="brand in sort(sub.brands)">
                <div class="content list-element">
                  <a href="javascript:void(0)" @click="loadCategory(sub.id, brand._id)">{{
                    brand.name
                  }}</a>

                  <a @click="copy(category.id, sub.id, brand._id)"
                    ><i class="share alternate icon"></i
                  ></a>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MIN_LINES_PER_CATEGORY = 10;

export default {
  name: "CategoryDropdown",
  props: ["category"],
  computed: {
    myWidth: function () {
      if (this.category && this.category.children) return 190 * this.lines.length || 1;
      return 200;
    },
    lines: function () {
      const sorted_lines = this.category.children
        .slice()
        .sort((a, b) => a.order - b.order);

      let MAX_BRANDS_ON_SUB = 0;
      for (let i = 0; i < this.category.children.length; i++) {
        const element = this.category.children[i];

        if (element.brands.length > MAX_BRANDS_ON_SUB)
          MAX_BRANDS_ON_SUB = element.brands.length;
      }

      const MAX_BRANDS_PER_SUB = MAX_BRANDS_ON_SUB <= 17 ? 10 : 17;

      const lines = [];
      let current_line = [];
      let current_line_items = 0;
      let remaining_line = false;

      for (let i = 0; i < sorted_lines.length; i++) {
        if (
          current_line.length > 0 &&
          current_line_items + sorted_lines[i].brands.length > MAX_BRANDS_PER_SUB
        ) {
          lines.push(current_line);
          current_line = [];
          current_line_items = 0;
        }

        current_line.push(sorted_lines[i]);
        current_line_items += sorted_lines[i].brands.length;
      }

      lines.push(current_line);

      return lines;
    },
  },
  methods: {
    sort(array) {
      const sorted = array.concat();

      return _.orderBy(sorted, "name", "asc");
    },
    loadCategory: function (categoryId, brandId) {
      const payload = {
        category: categoryId | null,
        brand: brandId,
      };

      this.$emit("onLoadProducts", payload);
    },
    copy: function (categoryId, subcategoryId, brandId) {
      const payload = {
        categoryId: categoryId,
        subcategoryId: subcategoryId,
        brandId: brandId,
      };
      this.$emit("onCopyLink", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.cat {
  padding: 15px;
  //background-color: #2a394f;
  background: rgb(239, 244, 250);
}
.sub-content {
}
.show-icon i {
  display: none !important;
}
.show-icon:hover i {
  display: block !important;
}
.list-element {
  display: flex;
  justify-content: space-between;
}
</style>
